import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  useSidebarContext,
  useSidebarActionsContext,
} from "../../Context/SidebarManagementContext";
import {
  useAMGSelectedContext,
  useAMGSelectedActionsContext,
  useSearchQueryActionContext,
  useCurrentPageActionContext,
  usePageSizeActionContext,
  useCopyFuncActionContext,
} from "../../Context/GlobalContext";
import { useAuthContext } from "../../Context/AuthContext";
import equipmentGroupStore from "../../Stores/EquipmentGroupStore";
import equipmentGroupConstants from "../../Constants/EquipmentGroupConstants";
import equipmentGroupActions from "../../Actions/EquipmentGroupActions";

import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import _, { isEmpty } from "lodash";
import EquipmentGroupContants from "../../Constants/EquipmentGroupConstants";
import commonUtils from "../../helpers/commonUtils";
import {
  useSelectedFilterActionsContext,
  useItemSelectedFilterActionsContext,
  useEquipmentStatusContext,
  useEquipmentStatusActionsContext,
} from "../../Context/GridEquipListContext";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AccordionUi from "../ReusableComponent/Accordion";
import SettingContent from "./SettingContent";
import { InputAdornment, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useLocation } from "react-router-dom";
import SideBarContent from "./SideBarContent";
import Access_ControlConstants from "../../Constants/Access_ControlConstants";
import access_ControlStore from "../../Stores/Access_ControlStores";
import equipmentStore from "../../Stores/EquipmentStore";
import EquipmentContants from "../../Constants/EquipmentConstants";

const Sidebar = () => {
  // const location = window.location.href;
  const location = useLocation();
  const { showSidebar, sidebarContentIsSetting } = useSidebarContext();
  const { setShowSidebar, handleContentChange } = useSidebarActionsContext();
  const isAuthenticated = useAuthContext();
  const selectedAnlageG = useAMGSelectedContext();
  const UpdateSelectedAnlageG = useAMGSelectedActionsContext();
  const UpdateSearchQuery = useSearchQueryActionContext();
  const UpdatePageSize = usePageSizeActionContext();
  const UpdateCurrentPage = useCurrentPageActionContext();
  const UpdateCopyFunktion = useCopyFuncActionContext();
  const updateEquipmentStatus = useEquipmentStatusActionsContext();
  const updateSelectedFilter = useSelectedFilterActionsContext();
  const updateListSelectedFilter = useItemSelectedFilterActionsContext();

  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();

  const [classname, setClassname] = useState("");
  const [equipmentGroupList, setEquipmentGroupList] = useState(null);
  const [equipmentGroupList_copy, setEquipmentGroupList_copy] = useState([]);
  const [activeTab, setActiveTab] = useState(selectedAnlageG);
  const [activeAccorder, setActiveAccorder] = useState(false);
  // const [activeLink, setActiveLink] = useState(1);

  const [search, setSearch] = useState("");
  const [message, setMessage] = useState("");
  const [searchQueryRefresh, setSearchQueryRefresh] = useState(0);
  const debounceFn = useCallback(_.debounce(handleDebounceFn, 1000), []);

  const [renderMe, setRenderMe] = useState(null);
  const inputRef = useRef("");
  const [plantList, setPlantList] = useState(null);
  const [copyplantList, setCopyPlantList] = useState(null);
  const [contentSettingAccordion, setContentSettingAccordion] = useState(0);
  const [equipmentGrpGroupState, setEquipmentGrpGroupState] = useState(null);
  const [path, setPath] = useState("");
  const isSideBarVisible =
    commonUtils.isUserWebsiteAdmin() ||
    commonUtils.isSupportUser() ||
    commonUtils.isManageTicketUser() ||
    (location.pathname.includes("/setting/ManageTicket/") &&
      commonUtils.hasManageTicketPermission() &&
      !commonUtils.isUserOrganisationAdmin() &&
      !commonUtils.isUserWerkAdmin() &&
      !commonUtils.isAdmin());
  const handelOnChange = (e) => {
    debounceFn(e.target.value);
  };

  function handleDebounceFn(inputValue) {
    setGlobalSpinner(true);
    setSearch(search !== "" ? inputValue : inputValue.trim());
  }

  const onItemSelected = useCallback(
    (eqG, eqbezeichnung, copyfunc, selectedPlant) => {
      updateEquipmentStatus("not");
      updateSelectedFilter("");
      updateListSelectedFilter([]);
      setActiveTab(eqG);
      UpdateSelectedAnlageG(eqG);
      UpdateCopyFunktion(copyfunc);
      UpdateCurrentPage(1);
      UpdatePageSize(1000);
      sessionStorage.setItem("plant", selectedPlant);
      sessionStorage.setItem("eqBez", eqbezeichnung);
    },
    [
      UpdateSelectedAnlageG,
      UpdateSearchQuery,
      UpdateCurrentPage,
      UpdatePageSize,
      UpdateCopyFunktion,
    ],
  );

  const fetchData = useCallback(() => {
    if (isAuthenticated) {
      setGlobalSpinner(true);
      equipmentGroupActions.getEquipmentGroupListByPlant(
        sessionStorage.getItem("userid"),
      );
    } else {
      setPlantList(null);
      setEquipmentGroupList(null);
      setEquipmentGroupList_copy(null);
      setCopyPlantList(null);
      setActiveAccorder(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (sidebarContentIsSetting && plantList) {
      sessionStorage.setItem(
        "plant",
        equipmentGroupList[plantList[0]][0]["plantId"] + "-" + plantList[0],
      );
      sessionStorage.setItem(
        "eqBez",
        equipmentGroupList[plantList[0]][0]["bezeichnung"],
      );
      sessionStorage.setItem(
        "eqGId",
        equipmentGroupList[plantList[0]][0]["id"],
      );
      setActiveTab(equipmentGroupList[plantList[0]][0]["id"]);
      UpdateSelectedAnlageG(equipmentGroupList[plantList[0]][0]["id"]);
      setActiveAccorder(0);
    }
  }, [sidebarContentIsSetting]);

  useEffect(() => {
    const currentpage = location.pathname.includes("/setting/")
      ? "setting"
      : location.pathname.includes("/dashboard")
        ? "dashboard"
        : "equipmentGrpEqiupment";
    handleContentChange(currentpage);
    // if (location.pathname.includes("/setting/") && !sidebarContentIsSetting) {
    //   handleContentChange(true);
    // }
    return () => {
      setEquipmentGroupList(null);
    };
  }, []);

  useEffect(() => {
    fetchData();

    return () => {};
  }, [fetchData]);

  useEffect(() => {
    if (!showSidebar) {
      setClassname("");
    } else {
      setClassname("active");
    }
  }, [showSidebar]);

  useEffect(() => {
    if (equipmentGroupList) {
      setGlobalSpinner(true);
      if (search.length != 0) {
        var tmp = { ...equipmentGroupList_copy };
        var filterlist = {};
        copyplantList.map((item) => {
          const _itemlist = tmp[item].filter((item) =>
            item.bezeichnungsDisplay
              .toLowerCase()
              .includes(search.toLowerCase()),
          );
          if (_itemlist.length > 0) {
            filterlist[item] = _itemlist;
          }
        });
        const _tempPlantlist = copyplantList.filter((item) =>
          Object.keys(filterlist).includes(item),
        );
        setPlantList(_tempPlantlist);
        setEquipmentGroupList(filterlist);
        setSearchQueryRefresh(1);
        if (_tempPlantlist.length > 0) {
          if (message !== "") {
            setMessage("");
          }
        } else if (message === "") {
          setMessage(localization.noRecordFound);
        }
      } else if (search.length === 0 && searchQueryRefresh === 1) {
        var tmp = { ...equipmentGroupList_copy };
        setPlantList(copyplantList);
        setSearchQueryRefresh(0);
        setEquipmentGroupList(tmp);
        setMessage("");
      }
    } else if (equipmentGroupList && searchQueryRefresh === 1) {
      var tmp = [...equipmentGroupList_copy];
      var res = tmp.filter((item) =>
        item.bezeichnungsDisplay.toLowerCase().includes(search.toLowerCase()),
      );

      setEquipmentGroupList(res);
      setSearchQueryRefresh(1);
    }
    setGlobalSpinner(false);
  }, [search]);

  /**---------------------Useeffect for equipmentGroup By plant----------------- */
  useEffect(() => {
    function updateEquipmentGroup() {
      var res = equipmentGroupStore.getEquipmentGroupListByPlant();
      let _plntList = Object.keys(res);
      let selectedPlant;

      if (!isEmpty(res)) {
        setPlantList(_plntList);
        setCopyPlantList(_plntList);
        let EqG_id_ini =
          sessionStorage.getItem("eqGId") !== null &&
          sessionStorage.getItem("eqGId") !== undefined
            ? sessionStorage.getItem("eqGId")
            : res != null
              ? res[_plntList[0]][0].id
              : 0;

        if (sessionStorage.getItem("eqGId") === null) {
          selectedPlant = res[_plntList[0]][0].plantId + "-" + _plntList[0];
          setActiveAccorder(0);
        } else {
          _plntList.some((plant, index) => {
            const isFind = res[plant].find((eqlist) => {
              return eqlist.id === EqG_id_ini;
            });
            if (isFind) {
              selectedPlant = res[plant][0].plantId + "-" + plant;
              setActiveAccorder(index);
              return true;
            }
          });
        }

        let EqG_Bez_ini =
          sessionStorage.getItem("eqBez") !== null &&
          sessionStorage.getItem("eqBez") !== undefined
            ? sessionStorage.getItem("eqBez")
            : res != null
              ? res[_plntList[0]][0].bezeichnung
              : 0;
        let EqG_copyFunc_ini =
          sessionStorage.getItem("copyFunktion") !== null &&
          sessionStorage.getItem("copyFunktion") !== undefined
            ? sessionStorage.getItem("copyFunktion")
            : 1;
        onItemSelected(
          EqG_id_ini,
          EqG_Bez_ini,
          EqG_copyFunc_ini,
          selectedPlant,
        );
        setEquipmentGroupList(res);
        setEquipmentGroupList_copy(res);
        setEquipmentGrpGroupState({
          plantNameList: _plntList,
          response: res,
        });
        if (message !== "") {
          setMessage("");
        }
      } else {
        if (message === "") {
          setMessage(localization.noRecordFound);
        }
        setEquipmentGroupList(null);
        setEquipmentGroupList_copy(null);

        setGlobalSpinner(false);
      }
    }

    function updateEquipmentGroupFailure() {
      var res = equipmentGroupStore.getEquipmentGroupListByPlant();
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_EQUIPMENTGROUP_BY_PLANT_SUCCESS,
      updateEquipmentGroup,
    );

    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_EQUIPMENTGROUP_BY_PLANT_FAILURE,
      updateEquipmentGroupFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_EQUIPMENTGROUP_BY_PLANT_SUCCESS,
        updateEquipmentGroup,
      );
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_EQUIPMENTGROUP_BY_PLANT_FAILURE,
        updateEquipmentGroupFailure,
      );
    };
  }, []);

  useEffect(() => {
    let _render = null;

    if (equipmentGroupList) {
      _render = (
        <AccordionUi
          plantList={plantList}
          path={path}
          equipmentGroupList={equipmentGroupList}
          onClick={onItemSelected}
          activeTab={activeTab}
          setActiveAccorder={setActiveAccorder}
          activeAccorder={activeAccorder}
        />
      );
    }

    setRenderMe(_render);
  }, [equipmentGroupList, activeTab]);

  /**------------------------------ Equipment group on Add Event occur to update SideBar List Start------------------------------*/
  useEffect(() => {
    function addOrUpdateEquipmentGroupSuccess() {
      equipmentGroupActions.getEquipmentGroupListByPlant(
        sessionStorage.getItem("userid"),
      );
    }
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_GROUP_SUCCESS,
      addOrUpdateEquipmentGroupSuccess,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_GROUP_SUCCESS,
        addOrUpdateEquipmentGroupSuccess,
      );
    };
  }, []);
  /**------------------------------ Equipment group on Add Event occur to update SideBar List Start------------------------------*/
  /**------------------------------ Equipment group on delete Event occur to update SideBar List Start------------------------------*/
  useEffect(() => {
    function deleteEquipmentGroupSuccess() {
      setGlobalSpinner(true);
      equipmentGroupActions.getEquipmentGroupListByPlant(
        sessionStorage.getItem("userid"),
      );
    }
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.DELETE_EQUIPMENT_GROUP_SUCCESS,
      deleteEquipmentGroupSuccess,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.DELETE_EQUIPMENT_GROUP_SUCCESS,
        deleteEquipmentGroupSuccess,
      );
    };
  }, []);

  /** ------------------------------Equipment group on delete Event occur to update SideBar List End------------------------------*/

  /** ------------------------------Equipment group on copy event occur to update sidebar list Start------------------------------ */
  useEffect(() => {
    function copyEquipmentGroupSuccess() {
      setGlobalSpinner(true);
      equipmentGroupActions.getEquipmentGroupListByPlant(
        sessionStorage.getItem("userid"),
      );
    }
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.COPY_EQUIPMENT_GROUP_SUCCESS,
      copyEquipmentGroupSuccess,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.COPY_EQUIPMENT_GROUP_SUCCESS,
        copyEquipmentGroupSuccess,
      );
    };
  }, []);
  /** ------------------------------ Update equipment count on bulk delete equipments Start ------------------------*/
  useEffect(() => {
    function bulkDeleteEquipmentSuccess() {
      setGlobalSpinner(true);
      equipmentGroupActions.getEquipmentGroupListByPlant(
        sessionStorage.getItem("userid"),
      );
    }
    access_ControlStore.addChangeListener(
      Access_ControlConstants.BULK_DELETE_ANLAGE_ATTRIBUTE_SUCCESS,
      bulkDeleteEquipmentSuccess,
    );
    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.BULK_DELETE_ANLAGE_ATTRIBUTE_SUCCESS,
        bulkDeleteEquipmentSuccess,
      );
    };
  }, []);
  /**--------------------------Update equipment count on bulk delete equipments End--------------------- */

  /** ------------------------------ Add equipment event occur to update sidebar list End ------------------------*/
  useEffect(() => {
    function addEquipmentSuccess() {
      setGlobalSpinner(true);
      equipmentGroupActions.getEquipmentGroupListByPlant(
        sessionStorage.getItem("userid"),
      );
    }
    equipmentStore.addChangeListener(
      EquipmentContants.INSERT_NEWEQUIPMENT_SUCCESS,
      addEquipmentSuccess,
    );
    return () => {
      equipmentStore.removeChangeListener(
        EquipmentContants.INSERT_NEWEQUIPMENT_SUCCESS,
        addEquipmentSuccess,
      );
    };
  }, []);
  /**--------------------------Add equipment event occur to update sidebar list End  --------------------- */

  /**-------------------------------------------------------------------------------------------- */
  // const ConditionalRendering = () => {
  //   if (
  //     commonUtils.isUserWebsiteAdmin() ||
  //     commonUtils.isSupportUser() ||
  //     commonUtils.isManageTicketUser() ||
  //     (location.pathname.includes("/setting/ManageTicket/") &&
  //       commonUtils.hasManageTicketPermission() &&
  //       !commonUtils.isUserOrganisationAdmin() &&
  //       !commonUtils.isUserWerkAdmin())
  //   ) {
  //     return <></>;
  //   } else {
  //     return (
  //       <>
  //         {/* {!sidebarContentIsSetting ? ( */}
  //         <nav id="sidebar" className={classname}>
  //           {!sidebarContentIsSetting ? (
  //             <div className="sidebar-header">
  //               <Typography className="sideBarHeader">
  //                 {localization.equipmentGroup}
  //               </Typography>
  //               <TextField
  //                 className="sideBarSearchCls"
  //                 ref={inputRef}
  //                 placeholder={localization.search}
  //                 variant="outlined"
  //                 autoFocus={true}
  //                 fullWidth
  //                 margin="normal"
  //                 onChange={handelOnChange}
  //                 defaultValue={search}
  //                 InputProps={{
  //                   startAdornment: (
  //                     <InputAdornment position="start">
  //                       <SearchIcon className="searchIconCls" />
  //                     </InputAdornment>
  //                   ),
  //                 }}
  //               />
  //               {renderMe}

  //               <span>{message}</span>
  //             </div>
  //           ) : (
  //             <SettingContent
  //               contentSettingAccordion={contentSettingAccordion}
  //               setContentSettingAccordion={setContentSettingAccordion}
  //             />
  //           )}
  //         </nav>
  //         {/* // ) : (

  //         // )} */}
  //         <div className="sidebar-footer">
  //           {!showSidebar && (
  //             <ChevronLeftIcon
  //               titleAccess={localization.hide}
  //               className="leftPanelToggleCls"
  //               onClick={() => {
  //                 setShowSidebar(true);
  //               }}
  //             />
  //           )}
  //           {showSidebar && (
  //             <ChevronRightIcon
  //               titleAccess={localization.show}
  //               className="leftPanelToggleCls"
  //               onClick={() => {
  //                 setShowSidebar(false);
  //               }}
  //             />
  //           )}
  //         </div>
  //       </>
  //     );
  //   }
  // };

  return isSideBarVisible ? (
    <></>
  ) : (
    <>
      <nav id="sidebar" className={classname}>
        {equipmentGrpGroupState !== null && (
          <SideBarContent
            equipmentGrpResponse={equipmentGrpGroupState}
            onItemSelected={onItemSelected}
          />
        )}
      </nav>
      <div className="sidebar-footer">
        {showSidebar && (
          <ChevronLeftIcon
            titleAccess={localization.hide}
            className="leftPanelToggleCls"
            onClick={() => {
              setShowSidebar(false);
            }}
          />
        )}
        {!showSidebar && (
          <ChevronRightIcon
            titleAccess={localization.show}
            className="leftPanelToggleCls"
            onClick={() => {
              setShowSidebar(true);
            }}
          />
        )}
      </div>
    </>
  );
  // equipmentGrpGroupState && (
  //   <SideBarContent equipmentGrpResponse={equipmentGrpGroupState} />
  // )

  // return <ConditionalRendering />;
};

export default Sidebar;
